import { useSelector } from "react-redux";
import { RootState } from "../../../../store/Index";
export const useThemeColors = () => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return {
    primaryColor: reduxTheme.primary_colors?.[400] || "#724E41",
    primaryHover: reduxTheme.primary_colors?.[50] || "#C29363",
    primaryTextColor: reduxTheme.primary_colors?.[100] || "#111827",
    secondaryHighlight: reduxTheme.primary_colors?.[300] || "#C29363",
    lightPrimary: reduxTheme.primary_colors?.[600] || "#E5BFA5",
    accentColor: reduxTheme.primary_colors?.[10] || "#a36e45",
    darkText: reduxTheme.primary_colors?.[100] || "#111827",
    secondaryText: reduxTheme.neutral_colors?.[800] || "#f0f4f8",
    neutralBackground: reduxTheme.neutral_colors?.[800] || "#f0f4f8",
    whiteColor: reduxTheme.primary_colors?.[900] || "#ffffff",
  };
};
